<template>
  <div class="section">
    <section class="container-fluid">
      <div class="columns">
        <div class="column is-8">
          <p class="is-inline">
            Get in touch at 
            <a href="mailto:contact@salaryseed.com" target="_blank" rel="noopener">contact@salaryseed.com</a> 
            <span class="separator">|</span>
            <span class="icon">
              <i class="fas fa-mobile-alt" aria-hidden="true"></i>
            </span>
            <a href="tel:+443301746770">+443301 746770</a>
            <span class="separator">|</span>
          </p>
          <address class="is-inline">Dock 75 Exploration Drive, Pioneer Park, Leicester, LE4 5NU</address>

          <p>
            <small>
              SalarySeed is owned by Pay Exchange Ltd, a registered company in England and Wales (company no. 13186367)
              <span class="separator">|</span>

              <router-link to="/privacy">Privacy policy</router-link>
            </small>
          </p>
        </div>

        <div class="column is-4 has-text-right-tablet">
          <p>Made with <span class="has-text-danger">♥</span> by <a href="https://polyprism.com" target="_blank" rel="noopener">Polyprism</a></p>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
  .container-fluid {
    padding-top: 1rem;
    border-top: 1px dashed #ddd;
    margin-top: 2rem;
  }

  .section {
    padding-top: 0;
  }
</style>
